<div class="profile">
  <div class="profile-image">
    @if (fileToken && !error) {
      <img
        [style.display]="loaded ? 'block' : 'none'"
        [attr.src]="fileToken | fileUrl"
        (load)="onLoad()"
        (error)="onError()"
        />
    }
    @if (!loaded || (error && loaded)) {
      <div class="avatar">
        <div class="initials">{{ name | ndtInitials }}</div>
      </div>
    }
  </div>
</div>
